import { render, staticRenderFns } from "./TravelClaimPost.vue?vue&type=template&id=b77055c4&"
import script from "./TravelClaimPost.vue?vue&type=script&lang=js&"
export * from "./TravelClaimPost.vue?vue&type=script&lang=js&"
import style0 from "./TravelClaimPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TravelClaimPost.vue"
export default component.exports